/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const RetryGroupSubmissionGradePassbackEnabledSettingParser = 
/* #__PURE__ */ parsers.object([
    [
        'name',
        /* #__PURE__ */ parsers.exactly('RETRY_GROUP_SUBMISSION_GRADE_PASSBACK_ENABLED'),
    ],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecBoolean)],
]);
export class RetryGroupSubmissionGradePassbackEnabledSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return RetryGroupSubmissionGradePassbackEnabledSettingParser.decode(input).map(res => new RetryGroupSubmissionGradePassbackEnabledSetting(res));
    }
    static unsafeDecode(input) {
        return RetryGroupSubmissionGradePassbackEnabledSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return RetryGroupSubmissionGradePassbackEnabledSettingParser.encode(data);
    }
    static schema() {
        return RetryGroupSubmissionGradePassbackEnabledSettingParser.schema();
    }
}
